import * as React from 'react';
import {
	Box,
	Button,
	DarkMode,
	Flex,
	Heading,
	HStack,
	VStack,
} from '@tempo/core';
import {ArrowBottomIcon} from '@tempo/icons';
import {NavLink} from '@tempo/nextjs';
import {useTranslation} from 'next-i18next';
import {Routes} from '@constants/routes';
import D4CLogo from '@components/D4CLogo';
import LandingBackground from './LandingBackground';

const LandingHeader = () => {
	const {t} = useTranslation('d4c');

	const seeMore = () => {
		window.scrollTo({
			top: window.innerHeight,
			left: 0,
			behavior: 'smooth',
		});
	};

	return (
		<DarkMode>
			<LandingBackground>
				<Flex
					direction="column"
					justifyContent="space-between"
					alignItems={{base: 'center', md: 'flex-start'}}
					textAlign={{base: 'center', md: 'left'}}
					height="100%"
					width="100%"
					py={{base: 'spacing.xl', md: 'spacing.3xl'}}
					px={{base: 'spacing.xl', sm: '40px', md: '136px'}}
					sx={{
						'@media screen and (max-aspect-ratio:1.2)': {
							alignItems: 'center',
							textAlign: 'center',
						},
					}}
				>
					<D4CLogo
						width={{base: '180px', md: '240px'}}
						alignSelf="flex-start"
					/>

					<VStack
						alignItems={{base: 'center', md: 'flex-start'}}
						spacing={{base: 'spacing.xl', md: 'spacing.3xl'}}
						sx={{
							'@media screen and (max-aspect-ratio:1.2)': {
								alignItems: 'center',
							},
						}}
					>
						<Heading
							variant={{base: 'display.m', md: 'display.l'}}
							color="text.neutral.primary.default"
							maxWidth="332px"
						>
							{t('unloggedhomepage_title_amplifyyourvoice_d4c-web')}
						</Heading>

						<HStack spacing="spacing.s">
							<NavLink href={Routes.SIGN_UP}>
								<Button data-testid="sign-up-button">
									{t('generic_action_signup_d4c-web')}
								</Button>
							</NavLink>
							<NavLink href={Routes.LOGIN}>
								<Button data-testid="login-button" variant="onDark">
									{t('generic_action_login_d4c-web')}
								</Button>
							</NavLink>
						</HStack>
					</VStack>

					<Box>
						<Button
							variant="ghost"
							onClick={seeMore}
							leftIcon={<ArrowBottomIcon />}
						>
							{t('unloggedhomepage_title_whatisXappname_d4c-web', {
								sprintf: ['Deezer for Creators'],
							})}
						</Button>
					</Box>
				</Flex>
			</LandingBackground>
		</DarkMode>
	);
};

export default LandingHeader;
